import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { PayrollExportId } from 'services/payrollExports/types';
import { AppState } from 'services/types';
import { makeSelectSubmittedAt } from './selectors';

export interface OwnProps {
    id: PayrollExportId;
}

interface ConnectedProps {
    submittedAt: string;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetSubmissionsSubmittedAtComponent extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { submittedAt } = this.props;

        if (!submittedAt) {
            return null;
        }

        return submittedAt;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    submittedAt: makeSelectSubmittedAt()
});

export default connect(mapStateToProps)(
    TimesheetSubmissionsSubmittedAtComponent
);
